// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YvCN","colMin":"styles_colMin__2vHud"};